import { Component, OnInit } from "@angular/core";
import { NgOptimizedImage } from "@angular/common";
import {
	ButtonComponent,
	ButtonType,
	DividerComponent,
	github,
	InputTextComponent,
	SnackbarService,
	ThemeService,
} from "design-system";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { AuthenticationService } from "../../services/authentication.service";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { SignaloidWrapperService } from "@shared/services/api-services/signaloid-wrapper.service";

@Component({
	selector: "lib-sign-in",
	imports: [NgOptimizedImage, ButtonComponent, DividerComponent, InputTextComponent, ReactiveFormsModule, RouterLink],
	standalone: true,
	templateUrl: "./sign-in.component.html",
	styleUrl: "./sign-in.component.css",
})
export class SignInComponent implements OnInit {
	credentials = new FormGroup({
		email: new FormControl("", [Validators.required, Validators.email]),
		password: new FormControl("", [Validators.required]),
	});

	constructor(
		private themeService: ThemeService,
		private authService: AuthenticationService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private signaloidWrapper: SignaloidWrapperService,
		private snackbarService: SnackbarService,
	) {}
	protected readonly ButtonType = ButtonType;
	ngOnInit() {
		localStorage.clear();
		this.themeService.setTheme("dark");
		this.checkVerifiedUser();
	}

	private checkVerifiedUser() {
		const verifyFlag = this.activatedRoute.snapshot.queryParamMap.get("r");
		if (!verifyFlag) return;
		const encoded = this.activatedRoute.snapshot.queryParamMap.get("data");

		if (encoded) {
			const decoded = JSON.parse(atob(encoded).toString());
			const { username } = decoded;
			const verificationCode = this.activatedRoute.snapshot.queryParamMap.get("code");
			if (!verificationCode) {
				throw new Error("Verification code is missing");
			}
			if (decoded && verificationCode) {
				this.authService
					.confirmSignUp(username, verificationCode)
					.then((res) => {
						if (res === "SUCCESS") {
							this.router.navigate(["/demo"]);
						}
					})
					.catch((err) => {
						console.log(err.message);
					});
			}
		} else {
			throw new Error("Invalid based64");
		}
	}

	submit() {
		this.snackbarService.removeSnackbar();
		if (this.credentials.valid && this.credentials.value.email && this.credentials.value.password) {
			this.signaloidWrapper
				.userSRPLogin(this.credentials.value.email, this.credentials.value.password)
				.then((res) => {
					this.router.navigate(["/demo"]);
				})
				.catch((err) => {
					this.snackbarService.openSnackbar({
						header: "Double check your credentials.",
						type: "error",
						description: "Email or password is incorrect. Check your credentials.",
					});
				});
		}
	}

	protected readonly github = github;
}
